function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const DEFAULT_MEETING_DURATION = 15;
const DEFAULT_NUMBER_OF_USERS = 7;
export const DEFAULT_AMANDA_AGENT_CONFIG = {
    UK: {
        DEFAULT: {
            num_users: 5,
            meeting_duration: DEFAULT_MEETING_DURATION
        }
    },
    US: {
        MM: {
            "work management": {
                meeting_duration: 30
            }
        },
        DEFAULT: {
            num_users: DEFAULT_NUMBER_OF_USERS,
            meeting_duration: DEFAULT_MEETING_DURATION
        }
    }
};
export const AMANDA_STATIC_VARIABLES = {
    is_platform_lead: "0",
    is_related_lead: "0",
    ai_intent: "0",
    expansion_potential: "0",
    ai_discovery_complete: "0",
    account_status: "new",
    intent: "none",
    acknowledgement_examples: "Got it. Perfect. Makes sense.",
    additional_instructions: "",
    needed_usercount: -1,
    address: "",
    description: "",
    lead_context: ""
};
const resolveConfig = (amandaAgentConfig, companySize, countryCode, product)=>{
    const size = companySize || "";
    let segment = "DEFAULT";
    if ([
        "1-19",
        "20-49",
        "50-99"
    ].includes(size)) segment = "SMB";
    else if ([
        "100-250",
        "251-1500"
    ].includes(size)) segment = "MM";
    else if ([
        "1500+"
    ].includes(size)) segment = "ENT";
    const countryBlock = (amandaAgentConfig === null || amandaAgentConfig === void 0 ? void 0 : amandaAgentConfig[(countryCode || "").toUpperCase()]) || {};
    const countryDefault = countryBlock.DEFAULT || {};
    const segmentBlock = countryBlock[segment] || {};
    const segmentDefault = segmentBlock.default || {};
    const productKey = (product || "").toLowerCase().trim();
    const productOverride = productKey && segmentBlock[productKey] ? segmentBlock[productKey] : {};
    const final = _object_spread({}, countryDefault, segmentDefault, productOverride);
    var _final_num_users;
    return {
        num_users: (_final_num_users = final.num_users) !== null && _final_num_users !== void 0 ? _final_num_users : null
    };
};
export const getAmandaConfigVariables = (leadData = {}, amandaAgentConfig)=>{
    const { country_code: countryCode, company_size: companySize, main_product: mainProduct } = leadData;
    const { num_users } = resolveConfig(amandaAgentConfig, companySize, countryCode, mainProduct);
    const result = {
        number_of_users_to_qualify: num_users !== null && num_users !== void 0 ? num_users : DEFAULT_NUMBER_OF_USERS
    };
    return result;
};
